import SparkleIcon from '../../assets/icons/sparkle-icon.svg';
import DocumentIcon from '../../assets/icons/check-document-icon.svg';
import AddPersonIcon from '../../assets/icons/add-person-icon.svg';
import PeopleIcon from '../../assets/icons/people-icon.svg';
import DependentsPetsIcon from '../../assets/icons/dependents-pets-icon.svg';
import AccountsAssetsIcon from '../../assets/icons/accounts-assets-icon.svg';
import DocumentsIcon from '../../assets/icons/documents-icon.svg';
import MemoriesIcon from '../../assets/icons/memories-icon.svg';

/**
 * Single clickable navigation entry.
 * match controls how active route detection is evaluated in Navigation.
 */
export type NavItem = {
  label: string;
  path: string;
  match?: "exact" | "prefix";
  disabled?: boolean;
  icon?: string;
};

/**
 * Optional grouping layer within a nav group.
 * title can be empty when the section only exists for structure/order.
 */
export type NavSubSection = {
  title: string;
  items: NavItem[];
};

/**
 * Top-level sidebar grouping rendered as a titled block in Navigation.
 */
export type NavGroup = {
  title: string;
  sections: NavSubSection[];
};

/**
 * Shared dashboard navigation config consumed by the Navigation shell.
 * Paths map directly to the frame routes used throughout the dashboard flow.
 */
export const unifiedDashboardNav: NavGroup[] = [
  {
    title: "Dashboard",
    sections: [
      {
        title: "",
        items: [
          { label: "Getting Started", path: "/frame-140", match: "exact", icon: SparkleIcon },
          { label: "My Plan Summary", path: "/frame-141", match: "exact", icon: DocumentIcon },
          { label: "Manage Access", path: "/frame-304", match: "exact", icon: AddPersonIcon },
        ],
      },
    ],
  },
  {
    title: "Records",
    sections: [
      {
        title: "",
        items: [
          { label: "People", path: "/frame-142", match: "exact", icon: PeopleIcon },
          { label: "Dependents and Pets", path: "/frame-146", match: "exact", icon: DependentsPetsIcon },
          { label: "Accounts and Assets", path: "/frame-143", match: "exact", icon: AccountsAssetsIcon },
          { label: "Documents", path: "/frame-144", match: "exact", icon: DocumentsIcon },
          { label: "Memory Collections", path: "/frame-145", match: "exact", icon: MemoriesIcon },
        ],
      },
    ],
  },
  {
    title: "Account",
    sections: [
      {
        title: "",
        items: [
          { label: "Settings", path: "/settings", match: "exact"},
          { label: "Support", path: "/frame-199", match: "exact"},
        ],
      },
    ],
  },
];